import { render, staticRenderFns } from "./EmojisWorkWithUs.vue?vue&type=template&id=04c281f2&scoped=true&"
import script from "./EmojisWorkWithUs.vue?vue&type=script&lang=js&"
export * from "./EmojisWorkWithUs.vue?vue&type=script&lang=js&"
import style0 from "./EmojisWorkWithUs.vue?vue&type=style&index=0&id=04c281f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c281f2",
  null
  
)

export default component.exports